<template>
</template>

<script>
export default {
  props: {
    reports: Object
  },
  computed: {
    startDownload() {
      return this.$store.getters['report/getStartDownload'];
    }
  },
  watch: {
    startDownload(status) {
      if (status === false) return; 
      this.updateSelectedReports();

      let allReports = JSON.parse(JSON.stringify(this.selectedReports));
      // AJOUTE LES ALL en reports
      allReports.forEach(report => {
        if (report.labelName === 'ALL') {
          report.src.saliencyreport.labelName = 'BASIC';
          report.src.aoitestreport.forEach(report => report.labelName = `AOI: ${report.name}`);
          allReports.push(report.src.saliencyreport, ...report.src.aoitestreport);
        }
      });
      // RETIRE LES ALL
      allReports = allReports.filter(report => {
        if (report.labelName === 'ALL') return false;
        return true;
      });
      // LINK FOR DOWNLOAD
      allReports.forEach((report, index) => setTimeout(() => {
        const link = document.createElement("a");
        link.style.display = 'none';
        document.body.appendChild(link);
        link.href = report.bundle;
        link.download = (report.labelName === 'BASIC' ? report.name + '__' : '') + report.labelName;
        link.click();
        document.body.removeChild(link);
      }, 2000 * index));
      // END LINK 

      this.$store.commit('report/setStartDownload', false);
    }
  },
  methods: {
    updateSelectedReports() {
      if (Object.keys(this.reports).length === 0) 
        return this.selectedReports = [];
      let selectedImgs = this.$store.getters["image/getMultiSelectImg"];
      let selectedReports = selectedImgs.map(imgUuid => {
        this.reports[imgUuid].srcUuid = imgUuid;
        return this.reports[imgUuid];
      });
      this.selectedReports = selectedReports;
    }
  },
  data() {
    return {
      selectedReports: []
    }
  }
}
</script>

<style>

</style>
